import React, { Component } from 'react'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import PropTypes from 'prop-types'
import DownloadIconSVG from 'component/svgComponents/download'

class ChartContainer extends Component {
  static propTypes = {
    title: PropTypes.string,
    indicators: PropTypes.array,
    children: PropTypes.array,
    headerStyle: PropTypes.object,
    bodyStyle: PropTypes.object,
    id: PropTypes.string,
    indicate: PropTypes.bool,
    t: PropTypes.func,
    data: PropTypes.array,
    onDownload: PropTypes.func,
  }

  renderIndicator = (color, description) => (
    <div
      key={description}
      style={{ display: 'flex', alignItems: 'center', marginLeft: 16 }}
    >
      <div style={{ width: 10, height: 10, background: color }} />
      <span style={{ marginLeft: 6, fontSize: 12 }}>{description}</span>
    </div>
  )

  onDownloadReport = (
    idBranches,
    dtPeriod,
    time,
    weight,
    quantity,
    reportType
  ) => {
    const { onDownload } = this.props;

    if (onDownload) {
      onDownload(idBranches, dtPeriod, time, weight, quantity, reportType);
    }
  };
  

  render() {
    const {
      title,
      indicators,
      children,
      headerStyle,
      bodyStyle,
      id,
      indicate,
      t,
      data,
    } = this.props

    return (
      <div
        style={{
          width: 1261,
          height: data && data.length ? 350 : 175,
          marginBottom: 20,
          display: 'flex',
          flexDirection: 'column',
          borderRadius: 8,
          boxShadow:
            '0 0 1px 0 rgba(161, 155, 162, 0.07), 0 2px 2px 0 rgba(60, 55, 56, 0.07), 0 0 0 1px rgba(60, 55, 56, 0.07)',
        }}
      >
        <div
          id='header-container'
          style={{
            background: '#fff',
            height: 'auto',
            display: 'flex',
            alignItems: 'center',
            padding: '21px 21px 0 21px',
            position: 'relative',
            borderRadius: '8px 8px 0px 0px',
            boxShadow:
              '0 0 1px 0 rgba(161, 155, 162, 0.07), 0 2px 2px 0 rgba(60, 55, 56, 0.07), 0 0 0 1px rgba(60, 55, 56, 0.07)',
            ...headerStyle,
          }}
        >
          <span
            style={{
              color: '#333333',
              fontSize: 20,
              fontWeight: 600,
            }}
          >
            {title}
          </span>
          {indicate && indicators && (
            <div style={{ position: 'absolute', left: 257, display: 'flex' }}>
              {indicators.map(({ color, description }) =>
                this.renderIndicator(color, description)
              )}
            </div>
          )}
          {data.length > 0 && (
            <button className='chart-button' onClick={this.onDownloadReport}>
            <DownloadIconSVG className="download-svg-small svg-green"/>

            <span className='chart-button-text'>
              {t('commonReport.download')}
            </span>
          </button>
          )}
        </div>
        <div
          id={id}
          style={{
            flex: 1,
            background: '#fff',
            padding: 21,
            ...bodyStyle,
            position: 'relative',
          }}
        >
          {children}
        </div>
        <div
          style={{
            width: '100%',
            height: 17,
            background: '#fff',
            borderRadius: '0px 0px 8px 8px',
            boxShadow:
              '0 0 1px 0 rgba(161, 155, 162, 0.07), 0 2px 2px 0 rgba(60, 55, 56, 0.07), 0 0 0 1px rgba(60, 55, 56, 0.07)',
          }}
        />
      </div>
    )
  }
}

const ChartContainerTranslated = translate(null, { wait: true })(ChartContainer)

export default connect()(ChartContainerTranslated)

export { ChartContainer }
